import {ChartLineOptions} from './options-type/chart-line-options';
import {ChartBarOptions} from './options-type/chart-bar-options';
import {ChartTypeDataInterface} from './interface/chart-type-data-interface';
import {ChartAreaOptions} from './options-type/chart-area-options';
import {ChartMapOptions} from './options-type/chart-map-options';

export class ChartType{

    public static readonly LINE : ChartTypeDataInterface = {
        id: ChartLineOptions.id,
        option: ChartLineOptions.getOptions(),
        additionalData: ChartLineOptions.getAdditionalData(),
        fill: ChartLineOptions.fill
    };

    public static readonly AREA : ChartTypeDataInterface = {
        id: ChartAreaOptions.id,
        option: ChartAreaOptions.getOptions(),
        additionalData: ChartAreaOptions.getAdditionalData(),
        fill: ChartAreaOptions.fill
    };

    public static readonly BAR : ChartTypeDataInterface = {
        id: ChartBarOptions.id,
        option: ChartBarOptions.getOptions(),
        additionalData: ChartBarOptions.getAdditionalData(),
        fill: ChartBarOptions.fill
    };

    public static readonly MAP : ChartTypeDataInterface = {
        id: ChartMapOptions.id,
        option: ChartMapOptions.getOptions(),
        additionalData: ChartMapOptions.getAdditionalData(),
        fill: ChartMapOptions.fill
    };
}



// WEBPACK FOOTER //
// ./src/app/components/charts/chart/model/chart-type.model.ts